import { render, staticRenderFns } from "./teamDetails.vue?vue&type=template&id=5309d110&scoped=true&"
import script from "./teamDetails.vue?vue&type=script&lang=js&"
export * from "./teamDetails.vue?vue&type=script&lang=js&"
import style0 from "./teamDetails.vue?vue&type=style&index=0&id=5309d110&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5309d110",
  null
  
)

export default component.exports